import classNames from 'classnames';

type CSSModuleClassMapping = {
  [key: string]: string;
};

export type CSSClassDefinition = string | Array<string>;

/*
  A helper function that can be used to resolve a set of classes to their css module name
  useful when passing a single class or an array of classes/modifiers to a component via props
 */
export const resolveClassNames = (
  className: CSSClassDefinition | null | undefined,
  styles: CSSModuleClassMapping,
): string => {
  if (!className) {
    return '';
  }

  if (Array.isArray(className)) {
    return classNames(className.map(classString => styles[classString]));
  }

  return styles[className] || '';
};
